import React from 'react';
import { ConnectionStatusContext } from './connection-status-context';

/** Returns the current connection status record (backward compatible). */
export function useConnectionStatus() {
    return React.useContext(ConnectionStatusContext).status;
}

/** Returns both current status and history for diagnostic purposes. */
export function useConnectionStatusDiagnostics() {
    return React.useContext(ConnectionStatusContext);
}
